<template>
  <div>
    <user-list
      :value="userList"
      :selected.sync="selectedUserList"
      :loading="loadingData"
      :search="search"
    >
      <template #footer>
        <v-btn
          color="accent"
          small
          append
          to="restore"
          v-text="$t('user.title.restoreUser')"
        />
      </template>
    </user-list>
    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedUserList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedUserList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="create"
        append
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _map from 'lodash/map'
import Repositories from 'src/repositories'

import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

import UserList from 'src/modules/user/components/UserList'

export default {
  name: 'CompanyUserListContainer',
  components: {
    AgFloatButtonContainer,
    AgConfirmDialog,
    UserList,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    userList: [],
    selectedUserList: [],
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    ...mapGetters('me', {
      userId: 'userId',
    }),
    removeMessage () {
      const count = this.selectedUserList.length
      return this.$tc('user.remove.message', count, { count })
    },
    hasCurrentUserInSelected () {
      return this.selectedUserList
        .some(user => user.userId === this.userId)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyUsers') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.userList = await Repositories.company.user.getList(this.companyId)
      this.loadingData = false
    },
    async removeSelected () {
      if (this.hasCurrentUserInSelected) {
        const notification = this.$t('user.remove.cantRemoveCurrentUser')
        this.showErrorNotification(notification)
      }
      else {
        try {
          this.loadingRemove = true
          const count = this.selectedUserList.length
          await Repositories.company.user.delete(this.companyId, _map(this.selectedUserList, 'userId'))
          const notification = this.$tc('user.remove.success', count, { count })
          this.showSuccessNotification(notification)
        }
        catch (error) {
          const notification = Repositories.parseErrorMessage(error)
          this.showErrorNotification(notification)
        }
        finally {
          this.loadingRemove = false
          this.selectedUserList = []
          this.fetchData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
